import { Modal } from "ui";

import {
  useCreateUsageGuideFaqItem,
  useUpdateUsageGuideFaqItem
} from "../../../apis";
import {
  UsageGuideFaqItemForm,
  UsageGuideFaqItemFormValues
} from "../../forms";
import { UsageGuideFaqItemModalProps } from "./UsageGuideFaqItemModal.types";

import styles from "./UsageGuideFaqItemModal.module.scss";

const USAGE_GUIDE_FAQ_ITEM_FORM_ID = "usage-guide-faq-item-form-id";

const UsageGuideFaqItemModal = ({
  isOpen,
  guideId,
  editableItem,
  onClose
}: UsageGuideFaqItemModalProps) => {
  const createFaqItem = useCreateUsageGuideFaqItem({ onSuccess: onClose });
  const updateFaqItem = useUpdateUsageGuideFaqItem({ onSuccess: onClose });

  const handleFormSubmit = (formData: UsageGuideFaqItemFormValues) => {
    if (editableItem) {
      updateFaqItem.mutate({ id: editableItem.id, ...formData });
    } else {
      createFaqItem.mutate({ guideId, ...formData });
    }
  };

  return (
    <Modal
      formId={USAGE_GUIDE_FAQ_ITEM_FORM_ID}
      isOpen={isOpen}
      title={`${editableItem ? "Edit" : "Add"} Question`}
      isLoading={createFaqItem.isLoading || updateFaqItem.isLoading}
      okText={editableItem ? "Save" : "Add"}
      contentClassName={styles.modal}
      onClose={onClose}
    >
      <UsageGuideFaqItemForm
        key={editableItem?.id ?? "new"}
        formId={USAGE_GUIDE_FAQ_ITEM_FORM_ID}
        onSubmit={handleFormSubmit}
        defaultValues={{
          question: editableItem?.question ?? "",
          answer: editableItem?.answer ?? "",
          isEnabled: editableItem?.isEnabled ?? true
        }}
      />
    </Modal>
  );
};

export default UsageGuideFaqItemModal;
